import {Button, FontIcon} from "@/app/_components";
import styles from './list.module.css';
import {DriveUtil} from "@/Master/DriveUtil";
import Load from "@/app/_components/Load/Load";
import React from "react";
import {RedeemRecordState} from "@/Core/Redeem/redeemEnum";
import {RedeemRecordInfo} from "@/Core/Redeem/redeemEntity";
import TrackRedeem from "@/Core/Track/TrackRedeem";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {RedeemRecordSuccessfulDialogFC} from "@/app/(redeem)/redeemRecord/RedeemRecordSuccessfulDialogFC";
import {RedeemRecordReviewDialogFC} from "@/app/(redeem)/redeemRecord/RedeemRecordReviewDialogFC";
import {RedeemRecordFailDialogFC} from "@/app/(redeem)/redeemRecord/RedeemRecordFailDialogFC";
import RedeemUtil from "@/Core/Redeem/RedeemUtil";
import {RedeemChannelType} from "@/Core/Redeem/RedeemChannelType";
import RedeemRecordItem from "@/app/(redeem)/redeemRecord/RedeemRecordItem";

type RedeemListProps = {
    listData: RedeemRecordInfo[],
    dataListOk?: boolean,
    onUpdateData: () => void
}

const status = {
    reCheck: '#FFA800',
    success: '#29D181',
    fail: '#FE414E',
}

const btnStyles = {
    color: '#fff',
    width: '1.7rem',
    height: '0.6rem',
}

const RedeemRecordList: React.FC<RedeemListProps> = (props) => {
    const {listData, dataListOk, onUpdateData} = props;

    const isDataOk = () => {
        return listData && listData.length > 0;
    }

    const getYuanImgName = (channelType:number) => {
        let typeName = "";
        if (channelType > 0){
            typeName = RedeemUtil.getChannelTypeName(channelType);
        }else{
            typeName = RedeemUtil.getChannelTypeName(RedeemChannelType.Paypal);
        }
        return `/img/redeem/img_y_${typeName}.webp`;
    }

    const updateState = (item: RedeemRecordInfo) => {
        let content;
        switch (item.state) {
            case RedeemRecordState.Successful:
                content = <>
                    <div style={{color: status.success}}>Successful</div>
                    <Button color="#33D24A" style={btnStyles} onClick={() => {
                        TrackRedeem.redeem_success_show();
                        //TODO UI逻辑订单成功信息页面
                        // checkButton.onClick.Add(() => { RedeemRecordSuccessfulDialog.OpenDialog(info); });
                        SDialogManagerFC.openDialog(RedeemRecordSuccessfulDialogFC, {
                            fcKey: SDialogManagerFC.getFCKey(RedeemRecordSuccessfulDialogFC),
                            recordInfo: item,
                            onClose: () => {
                                onUpdateData();
                            }
                        })
                    }}>Check</Button>
                </>
                break;
            case RedeemRecordState.ReviewCanCancel:
                content = <>
                    <div style={{color: status.reCheck}}>Under review</div>
                    <Button color="#0090FF" style={btnStyles} onClick={() => {
                        TrackRedeem.redeem_review_show();
                        //TODO 弹出和审核中弹窗，弹窗里面在调用下面取消的逻辑
                        //TODO UI逻辑订单取消信息页面
                        TrackRedeem.redeem_review_click(2)
                        SDialogManagerFC.openDialog(RedeemRecordReviewDialogFC, {
                            fcKey: SDialogManagerFC.getFCKey(RedeemRecordReviewDialogFC),
                            recordInfo: item,
                            from: 2,
                            onClose: () => {
                                onUpdateData();
                            }
                        });
                    }}>Cancel</Button>
                </>
                break;
            case RedeemRecordState.ReviewNoCancel:
                content = <>
                    <div style={{color: status.reCheck}}>Under review</div>
                </>
                break;
            case RedeemRecordState.Process:
                content = <>
                    <div style={{color: status.reCheck}}>Processing</div>
                </>
                break;
            default:
                content = <>
                    <div style={{color: status.fail}}>Fail</div>
                    <Button color={'#33D24A'} style={btnStyles} onClick={() => {
                        TrackRedeem.redeem_fail_show();
                        //todo 失败的界面  直接打开一个通用的失败界面
                        SDialogManagerFC.openDialog(RedeemRecordFailDialogFC, {
                            fcKey: SDialogManagerFC.getFCKey(RedeemRecordFailDialogFC),
                            recordInfo: item,
                            onClose: () => {
                                onUpdateData();
                            }
                        });
                    }}>Check</Button>
                </>
        }
        return content;
    }


    return (
        <section className={styles.wrapper}>
            <section className={styles.head}>
                <section className={`${styles.col}`}>Redemption</section>
                <section className={`${styles.col}`}>Account</section>
                <section className={`${styles.col}`}>Status</section>
            </section>

            {dataListOk ? (
                isDataOk() ? '' : <div className={styles.empty}>No Record Data...</div>
            ) : <Load/>}
            {
                dataListOk && (listData.map((item, index) => (
                    <RedeemRecordItem redeemRecordInfo={item} onUpdateData={onUpdateData} key={index} />
                    // <section className={styles.row} key={index}>
                    //     <section className={`${styles.col}`}>
                    //         <img
                    //             className={styles.icon_payment}
                    //             src={`${getYuanImgName(item.channelType)}`}
                    //         />
                    //         <span style={{
                    //             fontSize: '.5rem',
                    //             fontWeight: 'bold'
                    //         }}>{DriveUtil.ToDollarString(item.dollar)}</span>
                    //     </section>
                    //     <section className={`${styles.col}`}>
                    //         <div style={{marginBottom: '.1rem'}}>{item.account}</div>
                    //         <div>{item.dateTime}</div>
                    //     </section>
                    //     <section className={`${styles.col} ${styles.waiting}`}>
                    //         {updateState(item)}
                    //     </section>
                    // </section>
                )))
            }

            {/*<section className={styles.row}>*/}
            {/*    <section className={`${styles.col}`}>*/}
            {/*        <img className={styles.icon_payment} src="/img/ico_scs.png" alt=""/>*/}
            {/*        <span style={{fontSize: '.5rem', fontWeight: 'bold'}}>$499.99</span>*/}
            {/*    </section>*/}
            {/*    <section className={`${styles.col}`}>*/}
            {/*        <div>kimdz@yahoo.com</div>*/}
            {/*        <div>2024/09/10 14:00:00</div>*/}
            {/*    </section>*/}
            {/*    <section className={`${styles.col} ${styles.waiting}`}>*/}
            {/*        /!*<FontIcon item="s-success" style={{fontSize: '.5rem'}}/>*!/*/}
            {/*        <div style={{color: status.reCheck}}>Under review</div>*/}
            {/*        <Button*/}
            {/*            color="#0090FF"*/}
            {/*            style={{*/}
            {/*                color: '#fff',*/}
            {/*                width: '1.7rem',*/}
            {/*                height: '0.6rem',*/}
            {/*            }}*/}
            {/*        >Cancel</Button>*/}
            {/*    </section>*/}
            {/*</section>*/}

            {/*<section className={styles.row}>*/}
            {/*    <section className={`${styles.col}`}>*/}
            {/*        <img className={styles.icon_payment} src="/img/ico_scs.png" alt=""/>*/}
            {/*        <span style={{fontSize: '.5rem', fontWeight: 'bold'}}>$499.99</span>*/}
            {/*    </section>*/}
            {/*    <section className={`${styles.col}`}>*/}
            {/*        <div>kimdz@yahoo.com</div>*/}
            {/*        <div>2024/09/10 14:00:00</div>*/}
            {/*    </section>*/}
            {/*    <section className={`${styles.col} ${styles.waiting}`}>*/}
            {/*        /!*<FontIcon item="s-success" style={{fontSize: '.5rem'}}/>*!/*/}
            {/*        <div style={{color: status.success}}>Successful</div>*/}
            {/*        <Button*/}
            {/*            color="#33D24A"*/}
            {/*            style={{*/}
            {/*                color: '#fff',*/}
            {/*                width: '1.7rem',*/}
            {/*                height: '0.6rem',*/}
            {/*            }}*/}
            {/*        >Cancel</Button>*/}
            {/*    </section>*/}
            {/*</section>*/}

            {/*<section className={styles.row}>*/}
            {/*    <section className={`${styles.col}`}>*/}
            {/*        <img className={styles.icon_payment} src="/img/ico_scs.png" alt=""/>*/}
            {/*        <span style={{fontSize: '.5rem', fontWeight: 'bold'}}>$499.99</span>*/}
            {/*    </section>*/}
            {/*    <section className={`${styles.col}`}>*/}
            {/*        <div>kimdz@yahoo.com</div>*/}
            {/*        <div>2024/09/10 14:00:00</div>*/}
            {/*    </section>*/}
            {/*    <section className={`${styles.col} ${styles.waiting}`}>*/}
            {/*        /!*<FontIcon item="s-success" style={{fontSize: '.5rem'}}/>*!/*/}
            {/*        <div style={{color: status.fail}}>Fail</div>*/}
            {/*        <Button*/}
            {/*            color="#33D24A"*/}
            {/*            style={{*/}
            {/*                color: '#fff',*/}
            {/*                width: '1.7rem',*/}
            {/*                height: '0.6rem',*/}
            {/*            }}*/}
            {/*        >Cancel</Button>*/}
            {/*    </section>*/}
            {/*</section>*/}
        </section>
    )
}

export default RedeemRecordList;